export default function addTableColumns(editor, tableId, index) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  if (typeof index !== 'number') {
    throw new Error('Missing first table column insertion index');
  }

  return editor.withoutNormalizing(function () {
    for (var i = 0; i < n; i++) {
      editor.addTableColumn(tableId, index + i);
    }
  });
}